export default {
  dialogTitle: "新建畫布",
  canvasOptions: "畫布選項",
  canvasInfo: "畫布資訊",
  canvasType: {
    label: "畫布類型",
    placeholder: "請選擇畫布類型",
    multiCurrency: "多幣種畫布",
    singleCurrency: "單幣種畫布",
    solana: "solana畫布",
    tooltip:
      "多幣種畫布:支援Ethereum、BSC、Tron三條公鏈資料的多鏈多幣種同畫布分析，同時提供最全面的輔助分析功能\nsolana畫布:solana公鏈資料的畫布分析\n單幣種畫布：單鏈、單幣種、單地址畫布分析",
  },
  address: {
    label: "分析地址",
    labelWithHash: "分析地址/雜湊",
    placeholder: "請輸入地址或雜湊",
  },
  currency: {
    label: "幣種類型",
    placeholder: "請選擇幣種",
  },
  canvasName: {
    label: "畫布名稱",
    placeholder: "請輸入畫布名稱(必填)",
  },
  canvasDescription: {
    label: "畫布描述",
    placeholder: "請輸入畫布描述（200字以內）",
  },
  buttons: {
    reset: "重置",
    create: "新建",
  },
  validation: {
    canvasTypeRequired: "請選擇畫布類型",
    canvasConfigRequired: "請選擇畫布配置",
    currencyRequired: "請選擇幣種",
    addressRequired: "請輸入地址",
    canvasNameRequired: "案件名稱為必填項",
  },
};
